function saveDataWebToLead(data) {
  return fetch('https://mf13x5ajug.execute-api.us-east-1.amazonaws.com/prd/v1/api_lead_sf', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(data => data.json())
    .then(data => data)
    .catch(error => error)
}


// formulario eventos jamar
var formularioEventos = document.getElementById('formulario-eventos');
if (formularioEventos != null) {
  formularioEventos.addEventListener('submit', (e) => {

    $('#btn-feria').attr('disabled', true);

    if ($("#celular-feria").val() != "") {
      e.preventDefault();

      let dataSalesForceWebToLead = {
        "apellidos": $('#nombre-feria').val() + " " + $('#apellido-feria').val(),
        "origen": "Web Site",
        "correoElectronico":$('#correo-feria').val(),
        "idCliente":"JA_"+$('#cedula-feria').val(),
        "celular": "57"+$('#celular-feria').val(),
        "identificacion": $('#cedula-feria').val(),
        "tipoIdentificacion":"CEDULA DE CIUDADANIA",
        "departamento": "departamento : "+$('#departameto-feria').val()+" , ciudad : "+$('#ciudad-feria').val()+" , barrio : "+$('#barrio-feria').val() ,
        "empresa": "JA",
        "nomPais": "Colombia",
        "webSite": window.location.href ,
        "descripcion": "Formulario-eventos-jamar"
      };

      saveDataWebToLead(dataSalesForceWebToLead)
        .then(infoUser => {
          console.log(infoUser)
         // document.getElementById('formulario-rYg').submit()
          //alert(JSON.stringify(infoUser))
          console.log(infoUser)
          if(infoUser.success) {
            console.log("se envio correctamente");
          //window.location.href="/pages/eventos-jamar-confirmacion";
          }
        })
        .catch(error => {
          console.log('error al guardar -> ', error);
        })
    } else {
      alert('Error');
    }

  })
}



